<!--<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner [diameter]="40"></mat-spinner>
</div>-->
<div data-cy="patient-doctor-container">
  <div style="width: 100%; position: relative; display: flex;" data-cy="patient-doctor-header">
    <div style="flex: 1; color: var(--tdo-primary); font-weight: 500;" data-cy="patient-doctor-title">
      Edit Patient Doctors
    </div>
    <div matTooltip="Add Doctor" style="margin-left: auto; margin-right: 0; flex-basis: fit-content; cursor: pointer;" (click)="addNewPatientDoctor()" data-cy="patient-doctor-add-button">
      <mat-icon style="color: var(--tdo-primary-accent);">add_circle_outline</mat-icon>
    </div>
  </div>
  <app-tdo-accordion #accordion [allowMultiple]="false" data-cy="patient-doctor-accordion">
    <!--<ng-container>-->
      <ng-container *ngFor="let patientDoctor of this.data.dataPatientDoctors;">
        <app-tdo-accordion-item data-cy="patient-doctor-item">
          <app-tdo-accordion-item-header style="width: 100%;" data-cy="patient-doctor-item-header">
            <div style="display: flex;" data-cy="patient-doctor-summary">
              <mat-icon style="flex-basis: fit-content;" class="mr-2" data-cy="patient-doctor-icon">medical_services</mat-icon>
              <div style="flex: 1; display: flex;" data-cy="patient-doctor-name-container">
                <span style="flex-basis: 200px; position: relative;" data-cy="patient-doctor-name">{{getDoctorName(patientDoctor)}}</span><span style="flex: 1; font-weight: lighter; margin-left: 20px; position: relative; top: 2px; font-size: 12px;" data-cy="patient-doctor-type">{{patientDoctor.isReferring ? 'Referring Doctor' : 'Doctor' }}</span>
              </div>
              <div style="flex-basis: 25px; color: var(--tdo-secondary-accent); cursor: pointer;" matTooltip="Delete" (click)="deletePatientDoctor($event, patientDoctor)" data-cy="patient-doctor-delete-button">
                <mat-icon>delete</mat-icon>
              </div>
            </div>
          </app-tdo-accordion-item-header>
          <app-tdo-accordion-item-content data-cy="patient-doctor-item-content">
            <div style="background: white; border-radius: var(--border-radius); padding: var(--margin-size); display: flex;" data-cy="patient-doctor-details-form">
              <ng-container *ngIf="!isAddDoctorMode">
                <div (click)="isAddDoctorMode=true" style="cursor: pointer; margin-top: 14px; margin-left: 6px; margin-right: 6px; color: var(--tdo-secondary);" data-cy="patient-doctor-add-mode-button">
                  <mat-icon>add_circle_outline</mat-icon>
                </div>
                <mat-form-field class="form-field-with-right-marigin" data-cy="patient-doctor-select-field">
                  <mat-label data-cy="patient-doctor-select-label">Doctor</mat-label>
                  <mat-select [(ngModel)]="patientDoctor.DoctorID" data-cy="patient-doctor-select-dropdown">
                    <mat-option *ngFor="let doctor of doctorList" (onSelectionChange)="onDoctorSelect($event, patientDoctor, doctor)" [value]="doctor.DoctorId" data-cy="patient-doctor-select-option">Dr. {{ doctor.dataContact.FirstName }} {{ doctor.dataContact.LastName }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <div style="margin-left: 6px; margin-right: 6px;"></div>
                <app-validvalueselect *ngIf="patientDoctor.dataDoctorSpecialty" class="valid-value-select form-field-with-right-marigin"
                                      validvaluename="enumMedicalSpecialty"
                                      [showNoneOption]="true"
                                      [(selectedValue)]="patientDoctor.dataDoctorSpecialty.enumMedicalSpecialtyID"
                                      vvplaceholder="Specialty" data-cy="patient-doctor-specialty-select"></app-validvalueselect>

                <mat-checkbox style="margin-top: 14px;" [(ngModel)]="patientDoctor.isReferring" data-cy="patient-doctor-referring-checkbox">Referring doctor</mat-checkbox>
              </ng-container>
              <ng-container *ngIf="isAddDoctorMode">
                <div style="flex: 1;" data-cy="patient-doctor-add-form">
                  <div style="color: var(--tdo-primary); display: flex;" data-cy="patient-doctor-add-header">
                    <div style="flex: 1;" data-cy="patient-doctor-add-title">Add doctor details</div>
                    <div (click)="isAddDoctorMode=false" matTooltip="Cancel" style="cursor: pointer;" data-cy="patient-doctor-add-cancel-button"><mat-icon>clear</mat-icon></div>
                  </div>
                  <div class="patient-doctor-add-doctor" data-cy="patient-doctor-add-fields">
                    <span style="position: relative; top: 8px;" data-cy="patient-doctor-add-firstname-label">First Name: </span>
                    <input style="width: 100px" [(ngModel)]="addDoctorFirstName" data-cy="patient-doctor-add-firstname-input"/>
                    <span style="margin-left: 6px; position: relative; top: 8px;" data-cy="patient-doctor-add-lastname-label">Last Name: </span>
                    <input style="width: 100px" [(ngModel)]="addDoctorLastName" data-cy="patient-doctor-add-lastname-input"/>
                    <div style="flex: 1;"></div>
                    <button [disabled]="!addDoctorFirstName || !addDoctorLastName" (click)="onAddNewDoctorSave(patientDoctor)" class="tdo-button tdo-save" data-cy="patient-doctor-add-save-button">Save</button>
                  </div>
                </div>
              </ng-container>
            </div>
          </app-tdo-accordion-item-content>
        </app-tdo-accordion-item>
      </ng-container>
    <!--</ng-container>-->
  </app-tdo-accordion>
</div>
